import "./App.css"
import GenericError from "components/GenericError"
import AppSignal from "@appsignal/javascript"
import { ErrorBoundary } from "@appsignal/react"
import { useEffect } from "react"
import Router from "./router"
import { initializeAnalytics } from "./shared/analytics"

const appsignal = new AppSignal({
  key: process.env.REACT_APP_APPSIGNAL_KEY,
  namespace: process.env.REACT_APP_WHITELABEL
})

const App = () => {
  useEffect(() => {
    initializeAnalytics()
  }, [])
  const errorFallback = () => <GenericError />

  return (
    <ErrorBoundary instance={appsignal} fallback={errorFallback}>
      <Router />
    </ErrorBoundary>
  )
}

export default App
